import React from "react";

import { Icon } from "../../../Common";

const DropdownIndicator = () => (
  <div className="dropdown__arrow-container">
    <Icon className="dropdown__arrow-down" id="arrow-down" />
  </div>
);

export default DropdownIndicator;



// WEBPACK FOOTER //
// ./src/components/Common/Form/FormDropdown/DropdownIndicator.js